/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import * as moment from "moment";
import { countdownStyle } from "./styles";

type ICountdownTimerType = {
  start: number;
  restartTimer: boolean;
  count: (completeTask: number) => void;
};
export const CountdownTimer = (props: ICountdownTimerType) => {
  const { start, count, restartTimer } = props;
  // initialize timeLeft with the seconds prop
  const [timeLeft, setTimeLeft] = React.useState<number>(start);

  React.useEffect(() => {
    restartTimer && setTimeLeft(start);
  }, [restartTimer, start]);

  React.useEffect(() => {
    // exit early when we reach 0
    if (!timeLeft) {
      return;
    }
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    // clear interval on re-render to avoid memory leaks
    return () => {
      clearInterval(intervalId);
      count(timeLeft);
    };
  }, [timeLeft, start, count]);

  return (
    <span css={countdownStyle}>
      <div className="countdown-style my-3">
        You can request us to resend OTP in{" "}
        {moment.utc(timeLeft * 1000).format("mm:ss")}
      </div>
    </span>
  );
};
